import axios from "axios";

export const getFilesNas = async (path) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/api/filesNas`,
    {
      params: { path },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  return response.data;
};
